import { UntypedFormControl, ValidatorFn } from '@angular/forms';

export class PaymentValidators {
  public static cardNumber(symbols: number[] = [], ranges: number[][] = [[]]): ValidatorFn {
    return (control: UntypedFormControl) => {
      if (control.value || (typeof control.value === 'string' && control.value.trim())) {
        const value = control.value.replace(/ /g, '');
        const firstSymbol = +value[0];
        const first2Symbols = +value.slice(0, 2);
        const first3Symbols = +value.slice(0, 3);
        const first4Symbols = +value.slice(0, 4);
        const first6Symbols = +value.slice(0, 6);

        const isSomeSystemValidBySymbols = symbols.some((symbol) => {
          return symbol === firstSymbol ||
            symbol === first2Symbols ||
            symbol === first3Symbols ||
            symbol === first4Symbols ||
            symbol === first6Symbols;
        });
        
        const isSomeSystemValidByRange = ranges.some((range) => {
          return range[0]
            && range[1]
            && (firstSymbol >= range[0] && firstSymbol <= range[1] ||
              first2Symbols >= range[0] && first2Symbols <= range[1] ||
              first3Symbols >= range[0] && first3Symbols <= range[1] ||
              first4Symbols >= range[0] && first4Symbols <= range[1] ||
              first6Symbols >= range[0] && first6Symbols <= range[1]);
        });

        return isSomeSystemValidBySymbols || isSomeSystemValidByRange ? null : { cardNumber: true };
      }
      return null;
    }
  }
}
